import {
    DocumentData,
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore';
import { Pharmacy } from '../../Models';

export const userDataConverter: FirestoreDataConverter<Pharmacy> = {
    toFirestore(user: Pharmacy): DocumentData {
        return user;
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Pharmacy {
        const user = snapshot.data(options)!;
        return {
            id: snapshot.id,
            address: user.address,
            contact_number: user.contact_number,
            email: user.email,
            coordinates: user.coordinates,
            name: user.name,
            health_providers: user.health_providers,
            mp_credentials_state: user.mp_credentials_state,
            notifications_configuration: user.notifications_configuration,
        };
    },
};
